/**
 * HeritageWood — native wishlist (localStorage, no apps)
 * Storage key: hw_favorites  →  array of product handles
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'hw_favorites';
  var GRID_CLASSES =
    'product-grid product-grid--grid grid grid--4-col-desktop grid--2-col-tablet-down hw-wishlist-grid';

  function getFavorites() {
    try {
      var stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      if (!Array.isArray(stored)) return [];
      return stored
        .map(function (item) {
          if (typeof item === 'string') return item;
          if (item && item.handle) return String(item.handle);
          return '';
        })
        .filter(Boolean);
    } catch (err) {
      return [];
    }
  }

  function saveFavorites(list) {
    var unique = [];
    list.forEach(function (handle) {
      if (handle && unique.indexOf(handle) === -1) unique.push(handle);
    });
    localStorage.setItem(STORAGE_KEY, JSON.stringify(unique));
    document.dispatchEvent(new CustomEvent('hw:wishlist-updated', { detail: unique }));
    updateHeaderCount(unique.length);
  }

  function getSocialCountSpan(btn) {
    if (!btn || !btn.querySelector) return null;
    var countSpan = btn.querySelector('.hw-wishlist-btn__count');
    if (countSpan) return countSpan;
    return btn.querySelector('span');
  }

  function adjustSocialCount(btn, delta) {
    var span = getSocialCountSpan(btn);
    if (!span) return;
    var current = parseInt(String(span.textContent || '').replace(/[^\d-]/g, ''), 10);
    if (isNaN(current)) return;
    var next = current + delta;
    if (next < 0) next = 0;
    span.textContent = String(next);
    
    if (delta !== 0 && span.classList.contains('hw-wishlist-btn__count')) {
      span.style.transform = 'scale(1.4)';
      setTimeout(function() {
        span.style.transform = 'scale(1)';
      }, 200);
    }
  }

  function syncCardButtons() {
    var favorites = getFavorites();
    document.querySelectorAll('.hw-wishlist-btn').forEach(function (btn) {
      var handle = btn.dataset.productHandle || '';
      var active = handle && favorites.indexOf(handle) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');

      if (active && btn.getAttribute('data-hw-count-synced') !== 'true') {
        adjustSocialCount(btn, 1);
        btn.setAttribute('data-hw-count-synced', 'true');
      }
    });
  }

  function updateHeaderCount(count) {
    if (typeof count !== 'number') count = getFavorites().length;
    document.querySelectorAll('[data-hw-wishlist-count]').forEach(function (el) {
      el.textContent = String(count);
      if (count > 0) {
        el.removeAttribute('hidden');
      } else {
        el.setAttribute('hidden', '');
      }
    });
    document.querySelectorAll('.hw-header-wishlist').forEach(function (el) {
      el.setAttribute('href', '/pages/favorite');
      el.classList.toggle('has-items', count > 0);
    });
  }

  function toggleFavorite(handle, btn) {
    if (!handle) return;
    var list = getFavorites();
    var index = list.indexOf(handle);
    var adding = index === -1;

    if (adding) {
      list.push(handle);
    } else {
      list.splice(index, 1);
    }

    document.querySelectorAll('.hw-wishlist-btn').forEach(function (heart) {
      if ((heart.dataset.productHandle || '') !== handle) return;
      heart.classList.toggle('is-active', adding);
      heart.setAttribute('aria-pressed', adding ? 'true' : 'false');
      adjustSocialCount(heart, adding ? 1 : -1);
      if (adding) {
        heart.setAttribute('data-hw-count-synced', 'true');
      } else {
        heart.removeAttribute('data-hw-count-synced');
      }
    });

    saveFavorites(list);
  }

  function setupCardClicks() {
    document.addEventListener(
      'click',
      function (e) {
        var btn = e.target.closest('.hw-wishlist-btn');
        if (!btn) return;

        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

        toggleFavorite(btn.dataset.productHandle || '', btn);
      },
      true
    );
  }

  function nativeAddToCartForm(variantId, available) {
    var disabled = available === false || !variantId ? ' disabled' : '';
    var label = available === false || !variantId ? 'Indisponibil' : 'Adaugă în coș';
    return (
      '<div class="hw-quick-add-wrapper">' +
      '<form method="post" action="/cart/add" accept-charset="UTF-8" enctype="multipart/form-data" class="hw-quick-add-form">' +
      '<input type="hidden" name="form_type" value="product">' +
      '<input type="hidden" name="utf8" value="✓">' +
      '<input type="hidden" name="id" value="' +
      (variantId || '') +
      '" class="hw-variant-id-input">' +
      '<input type="hidden" name="quantity" value="1">' +
      '<button type="submit" name="add" class="hw-quick-add-btn"' +
      disabled +
      '><span class="hw-quick-add-btn__label">' +
      label +
      '</span></button>' +
      '</form>' +
      '</div>'
    );
  }

  function extractVariantId(doc) {
    if (!doc) return '';
    var input = doc.querySelector('form[action*="/cart/add"] input[name="id"], input[name="id"]');
    if (input && input.value) return input.value;
    var jsonEl = doc.querySelector('script[type="application/ld+json"]');
    return '';
  }

  function extractTitle(doc) {
    var el = doc.querySelector('h1, .product-title, [class*="product-title"] p');
    if (el && el.textContent.trim()) return el.textContent.trim();
    var og = doc.querySelector('meta[property="og:title"]');
    return og ? og.getAttribute('content') : '';
  }

  function extractImage(doc) {
    var img = doc.querySelector('.product-media img, media-gallery img, .card-gallery img, img[src*="cdn/shop"]');
    if (img) return img.getAttribute('src') || img.getAttribute('srcset') || '';
    var og = doc.querySelector('meta[property="og:image"]');
    return og ? og.getAttribute('content') : '';
  }

  function extractPrice(doc) {
    var el = doc.querySelector('product-price, .price, [class*="price"]');
    if (!el) return '';
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function findNativeCard(doc, handle) {
    var selectors = 'product-card, .card-wrapper, .product-grid__item, .hw-product-card-wrapper, .grid__item';
    var nodes = doc.querySelectorAll(selectors);
    var i;
    var node;
    var link;

    for (i = 0; i < nodes.length; i++) {
      node = nodes[i];
      link = node.querySelector('a[href*="/products/"]');
      if (link && handle && link.getAttribute('href').indexOf('/products/' + handle) !== -1) {
        return node;
      }
    }

    return null;
  }

  function stripBrokenWidgets(card) {
    card.querySelectorAll('script, quick-add-component, product-form-component, .quick-add').forEach(function (el) {
      el.remove();
    });
  }

  function ensureNativeForm(card, variantId) {
    stripBrokenWidgets(card);
    var existing = card.querySelector('.hw-quick-add-wrapper');
    if (existing) existing.remove();
    var host =
      card.querySelector('.product-card__content, .product-card__information, .product-grid__card, .card__content, .card-information') ||
      card;
    host.insertAdjacentHTML('beforeend', nativeAddToCartForm(variantId, Boolean(variantId)));
  }

  function wrapAsGridItem(node, handle, variantId) {
    var item = document.createElement('li');
    item.className = 'product-grid__item grid__item';
    item.setAttribute('data-product-handle', handle);

    var clone = document.importNode(node, true);
    if (clone.matches && clone.matches('li, .product-grid__item, .grid__item')) {
      item.innerHTML = clone.innerHTML;
    } else {
      item.appendChild(clone);
    }

    ensureNativeForm(item, variantId);
    return item;
  }

  function buildCardFromPage(doc, handle, variantId) {
    var title = extractTitle(doc) || handle;
    var image = extractImage(doc);
    var price = extractPrice(doc);
    var item = document.createElement('li');
    item.className = 'product-grid__item grid__item';
    item.setAttribute('data-product-handle', handle);
    item.innerHTML =
      '<div class="hw-product-card-wrapper card-wrapper">' +
      '<div class="hw-product-card__image-wrapper card__media">' +
      '<a href="/products/' +
      handle +
      '">' +
      (image
        ? '<img class="hw-product-card__image" src="' + image + '" alt="" width="600" height="600" loading="lazy">'
        : '') +
      '</a>' +
      '<button type="button" class="hw-wishlist-btn is-active" data-product-handle="' +
      handle +
      '" aria-pressed="true" aria-label="Elimină din favorite">' +
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>' +
      '</button>' +
      '</div>' +
      '<div class="product-card__information card__content">' +
      '<h3 class="product-card__title card__heading"><a href="/products/' +
      handle +
      '">' +
      title +
      '</a></h3>' +
      (price ? '<div class="price"><span class="price__amount">' + price + '</span></div>' : '') +
      nativeAddToCartForm(variantId, Boolean(variantId)) +
      '</div></div>';
    return item;
  }

  function parseHtml(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function fetchProductCard(handle) {
    return fetch('/products/' + encodeURIComponent(handle), { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('product page missing');
        return res.text();
      })
      .then(function (html) {
        var doc = parseHtml(html);
        var variantId = extractVariantId(doc);
        var nativeCard = findNativeCard(doc, handle);
        if (nativeCard) return wrapAsGridItem(nativeCard, handle, variantId);

        return fetch('/search?q=' + encodeURIComponent(handle), { credentials: 'same-origin' })
          .then(function (res) {
            return res.ok ? res.text() : '';
          })
          .then(function (searchHtml) {
            if (searchHtml) {
              var searchDoc = parseHtml(searchHtml);
              var searchCard = findNativeCard(searchDoc, handle);
              if (searchCard) {
                return wrapAsGridItem(searchCard, handle, variantId || extractVariantId(searchDoc));
              }
            }
            if (variantId) return buildCardFromPage(doc, handle, variantId);

            return fetch('/products/' + encodeURIComponent(handle) + '.js')
              .then(function (res) {
                return res.ok ? res.json() : null;
              })
              .then(function (product) {
                var id = product && product.variants && product.variants[0] ? product.variants[0].id : variantId;
                return buildCardFromPage(doc, handle, id);
              });
          });
      })
      .catch(function () {
        return null;
      });
  }

  function showEmpty(container) {
    var empty = document.getElementById('hw-wishlist-empty');
    if (empty) empty.hidden = false;
    if (container) {
      container.innerHTML = '';
      container.hidden = true;
    }
  }

  function showGrid(container) {
    var empty = document.getElementById('hw-wishlist-empty');
    if (empty) empty.hidden = true;
    if (container) {
      container.hidden = false;
      container.className = GRID_CLASSES;
    }
  }

  function hide404Extras() {
    if (location.pathname.indexOf('/pages/favorite') === -1) return;
    document.querySelectorAll('#MainContent .shopify-section').forEach(function (section) {
      if (!section.querySelector('#hw-wishlist-container')) {
        section.style.display = 'none';
      }
    });
  }

  function renderWishlistPage() {
    var container = document.getElementById('hw-wishlist-container');
    if (!container) return;
    if (container.getAttribute('data-hw-wishlist-inline') === 'true') return;

    hide404Extras();

    var handles = getFavorites();
    if (!handles.length) {
      showEmpty(container);
      return;
    }

    showGrid(container);
    container.innerHTML = '<li class="hw-wishlist-loading">Se încarcă favoritele…</li>';

    Promise.all(handles.map(fetchProductCard)).then(function (cards) {
      var valid = cards.filter(Boolean);
      container.innerHTML = '';
      if (!valid.length) {
        showEmpty(container);
        return;
      }
      valid.forEach(function (card) {
        container.appendChild(card);
      });
      syncCardButtons();
    });
  }

  document.addEventListener('hw:wishlist-updated', function () {
    var container = document.getElementById('hw-wishlist-container');
    if (!container) return;
    var handles = getFavorites();
    if (!handles.length) {
      showEmpty(container);
      return;
    }
    container.querySelectorAll('[data-product-handle]').forEach(function (card) {
      if (handles.indexOf(card.getAttribute('data-product-handle')) === -1) {
        card.remove();
      }
    });
    if (!container.querySelector('[data-product-handle]')) {
      showEmpty(container);
    }
  });

  function watchDynamicButtons() {
    if (typeof MutationObserver === 'undefined' || !document.body) return;
    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        syncCardButtons();
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    setupCardClicks();
    syncCardButtons();
    updateHeaderCount();
    renderWishlistPage();
    watchDynamicButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
